"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var styled_components_1 = __importDefault(require("styled-components"));
// Api
var api_1 = require("@src/api");
// Actions
var BotActions_1 = require("@src/actions/BotActions");
// Constants
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
var utils_1 = require("@src/utils");
var TabContainer_1 = __importDefault(require("../../components/TabContainer"));
var maps_1 = require("./maps");
var inputs_1 = __importDefault(require("./inputs"));
var const_1 = require("./const");
var SET_COMMERCE_DATA = const_1.REDUCER_ACTIONS.SET_COMMERCE_DATA, SET_COMMERCE_DATA_EDITED = const_1.REDUCER_ACTIONS.SET_COMMERCE_DATA_EDITED, SET_LOADER = const_1.REDUCER_ACTIONS.SET_LOADER, SET_ERROR_LIST = const_1.REDUCER_ACTIONS.SET_ERROR_LIST, ADD_TO_ERROR_LIST = const_1.REDUCER_ACTIONS.ADD_TO_ERROR_LIST, REMOVE_FROM_ERROR_LIST = const_1.REDUCER_ACTIONS.REMOVE_FROM_ERROR_LIST;
var ComponentContainer = styled_components_1["default"]('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 24px;\n  max-width: 500px;\n\n  > div {\n    margin-top: 24px;\n  }\n\n  > div:last-child {\n    margin-top: 8px;\n  }\n"], ["\n  margin-top: 24px;\n  max-width: 500px;\n\n  > div {\n    margin-top: 24px;\n  }\n\n  > div:last-child {\n    margin-top: 8px;\n  }\n"])));
var initialState = {
    commerceData: {
        enableCommercePlus: false,
        botName: '',
        enableOverridingStagingURL: false,
        overridingStagingURL: '',
    },
    commerceDataEdited: false,
    loader: false,
    errorList: [],
};
var reducer = function (state, action) {
    var type = action.type, data = action.data;
    switch (type) {
        case SET_COMMERCE_DATA:
            return __assign(__assign({}, state), { commerceData: data, commerceDataEdited: true });
        case SET_COMMERCE_DATA_EDITED:
            return __assign(__assign({}, state), { commerceDataEdited: data });
        case SET_LOADER:
            return __assign(__assign({}, state), { loader: data });
        case SET_ERROR_LIST:
            return __assign(__assign({}, state), { errorList: data });
        case ADD_TO_ERROR_LIST:
            return __assign(__assign({}, state), { errorList: !state.errorList.includes(data)
                    ? __spreadArrays(state.errorList, [data]) : state.errorList });
        case REMOVE_FROM_ERROR_LIST:
            return __assign(__assign({}, state), { errorList: state.errorList.filter(function (item) { return item !== data; }) });
        default:
            return state;
    }
};
var commercePlusActions = function (dispatch) { return ({
    setCommerceData: function (commercePlusData) {
        dispatch({
            type: SET_COMMERCE_DATA,
            data: commercePlusData,
        });
    },
    setCommerceDataEdited: function (commerceDataEdited) {
        dispatch({
            type: SET_COMMERCE_DATA_EDITED,
            data: commerceDataEdited,
        });
    },
    setLoader: function (loader) {
        dispatch({
            type: SET_LOADER,
            data: loader,
        });
    },
    setErrorList: function (errorList) {
        dispatch({
            type: SET_ERROR_LIST,
            data: errorList,
        });
    },
    addToErrorList: function (error) {
        dispatch({
            type: ADD_TO_ERROR_LIST,
            data: error,
        });
    },
    removeFromErrorList: function (error) {
        dispatch({
            type: REMOVE_FROM_ERROR_LIST,
            data: error,
        });
    },
}); };
var CommercePlus = function () {
    var _a = react_1.useReducer(reducer, initialState), state = _a[0], dispatch = _a[1];
    var actions = commercePlusActions(dispatch);
    var commerceData = state.commerceData, loader = state.loader, commerceDataEdited = state.commerceDataEdited, errorList = state.errorList;
    var businessId = react_redux_1.useSelector(maps_1.stateToProps).businessId;
    var validateData = function (data) {
        var enableCommercePlus = data.enableCommercePlus, enableOverridingStagingURL = data.enableOverridingStagingURL, botName = data.botName, overridingStagingURL = data.overridingStagingURL;
        var keys = Object.keys(data);
        var values = Object.values(data);
        var BOT_NAME = const_1.COMMERCE_PLUS.BOT_NAME, ENABLE_OVERRIDING_STAGING_URL = const_1.COMMERCE_PLUS.ENABLE_OVERRIDING_STAGING_URL, OVERRIDING_STAGING_URL = const_1.COMMERCE_PLUS.OVERRIDING_STAGING_URL;
        keys.forEach(function (key, index) { return __awaiter(void 0, void 0, void 0, function () {
            var value, overridingURLCondition;
            return __generator(this, function (_a) {
                if (enableCommercePlus) {
                    value = values[index];
                    overridingURLCondition = (key === OVERRIDING_STAGING_URL &&
                        enableOverridingStagingURL &&
                        !value) ||
                        (key === ENABLE_OVERRIDING_STAGING_URL &&
                            !overridingStagingURL &&
                            value);
                    if ((key === BOT_NAME && !value) || !botName) {
                        actions.addToErrorList(BOT_NAME);
                    }
                    else if (overridingURLCondition) {
                        actions.addToErrorList(OVERRIDING_STAGING_URL);
                    }
                    else {
                        actions.removeFromErrorList(key);
                    }
                }
                else {
                    actions.removeFromErrorList(key);
                }
                return [2 /*return*/];
            });
        }); });
    };
    var handleInputChange = function (key, value) {
        var _a, _b;
        actions.setCommerceData(__assign(__assign({}, commerceData), (_a = {}, _a[key] = value, _a)));
        validateData(__assign(__assign({}, commerceData), (_b = {}, _b[key] = value, _b)));
    };
    var getCommercePlusData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, response, commerceDataFromApi, error_1;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    actions.setLoader(true);
                    return [4 /*yield*/, api_1.API.businessV2.getBusinessData(businessId)];
                case 1:
                    _a = _c.sent(), success = _a.success, response = _a.response;
                    if (success) {
                        commerceDataFromApi = (_b = response === null || response === void 0 ? void 0 : response.body) === null || _b === void 0 ? void 0 : _b.commerce_data;
                        actions.setCommerceData({
                            enableCommercePlus: commerceDataFromApi.enable_commerce,
                            enableOverridingStagingURL: commerceDataFromApi.enable_commerce_url,
                            botName: commerceDataFromApi.commerce_client_name,
                            overridingStagingURL: commerceDataFromApi.commerce_url,
                        });
                        actions.setCommerceDataEdited(false);
                    }
                    else {
                        BotActions_1.createAlert(response.error, null, MogamboConstants_1.AlertTypes.NEGATIVE);
                    }
                    actions.setLoader(false);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _c.sent();
                    actions.setLoader(false);
                    api_1.captureException(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var saveCommercePlusData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var fieldName, _a, success, response, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 4, , 5]);
                    if (!(errorList.length > 0)) return [3 /*break*/, 1];
                    fieldName = errorList.includes('botName')
                        ? 'Bot Name'
                        : 'Overriding Staging URL';
                    BotActions_1.createAlert("Please enter " + fieldName + " before saving.", null, MogamboConstants_1.AlertTypes.NEGATIVE);
                    return [3 /*break*/, 3];
                case 1:
                    actions.setLoader(true);
                    return [4 /*yield*/, api_1.API.businessV2.updateBusinessData(businessId, {
                            commerce_client_name: commerceData.botName,
                            commerce_url: commerceData.overridingStagingURL,
                            enable_commerce: commerceData.enableCommercePlus,
                            enable_commerce_url: commerceData.enableOverridingStagingURL,
                            is_commerce_plus: true,
                            id: businessId,
                        })];
                case 2:
                    _a = _b.sent(), success = _a.success, response = _a.response;
                    if (success) {
                        BotActions_1.createAlert('Commerce+ data saved successfully!', undefined, MogamboConstants_1.AlertTypes.POSITIVE);
                        actions.setCommerceDataEdited(false);
                    }
                    else {
                        BotActions_1.createAlert(response.error, null, MogamboConstants_1.AlertTypes.NEGATIVE);
                    }
                    actions.setLoader(false);
                    _b.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    error_2 = _b.sent();
                    actions.setLoader(false);
                    api_1.captureException(error_2);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var renderCommerceFields = function () {
        return inputs_1["default"].inputs.map(function (input) {
            var Component = input.component;
            var props = input.props(commerceData, handleInputChange);
            return (react_1["default"].createElement(Component, __assign({ themed: true, label: input.label, key: input.key }, props)));
        });
    };
    react_1.useEffect(function () {
        getCommercePlusData();
    }, []);
    return (react_1["default"].createElement(TabContainer_1["default"], { title: "Commerce+", isSaveDisabled: !commerceDataEdited || utils_1.isProduction(), isLoaderActive: loader, onSave: saveCommercePlusData },
        react_1["default"].createElement(ComponentContainer, null, renderCommerceFields())));
};
exports["default"] = CommercePlus;
var templateObject_1;
